module.exports = __webpack_public_path__ + "img/8.b125bd99.jpg";